export default "__VITE_ASSET__DWNHVm$t__"